<template>
  <header :data-thalamus-componentes="libVersion">
    <div class="linha">
      <div class="coluna">
        <nav class="jm jm-menu nav-maior none" id="menu">
          <div class="separador">
            <a v-for="modulo in menus" v-bind:key="modulo.id" :href="modulo.URL"
              :class="moduleName == modulo.nome ? 'ativo' : ''">{{ modulo.nome }}</a>
          </div>
        </nav>
        <a :href="linkPortal" class="logo logo-menor">Thalamus</a>
        <a href="#" class="icone-avancar negrito com-texto"
          onclick="document.getElementById('menu').classList.toggle('none');this.classList.toggle('ativo');return false">
          {{ moduleName }}</a>
      </div>

      <div class="linha  alinha-v">


        <span
          v-if="nomeUsuarioCurto || nomeEmpresaHeader"
          class="empresa-header"
          :title="tituloIdentidadeHeader"
        >
          <span v-if="nomeUsuarioCurto" class="empresa-header__nome">{{ nomeUsuarioCurto }}</span>
          <span v-if="nomeEmpresaHeader" class="empresa-header__empresa">{{ nomeEmpresaHeader }}</span>
        </span>

        <div class="header-notif">
          <a
            href="#"
            class="icone-notif direita"
            :class="{ ativo: notifDropdownAberto }"
            title="Notificacoes"
            style="box-sizing: unset"
            :rel="totalNotificacoes > 0 ? totalNotificacoes : null"
            @click.prevent="toggleNotificacoes"
          ></a>

          <nav class="jm jm-notif" :class="{ none: !notifDropdownAberto }" id="notificacoes">
            <div
              v-if="notificacoes.length === 0 && !notifLoading"
              class="separador"
            >
              <div class="fonte-fraca">Nenhuma notificação</div>
            </div>
            <div
              v-else
              class="separador notif-lista"
              @scroll="onNotifScroll"
            >
              <div v-for="notif in notificacoes" :key="notif.id" class="notif-item">
                <div style="display: flex; flex-direction: row">
                  <div @click="lerNotificacao(notif)" style="padding: 10px 0px 0px 10px; margin: 0; width: 100%;">
                    <p :style="{ 'opacity': (notif.status ? '0.5' : '') }" class="texto">
                      {{ notif.msg }}
                    </p>
                  </div>
                  <div class="fonte-menor fonte-fraca"
                    style="display: flex; flex-flow: column; justify-content: space-between; align-items: end; padding: 10px 0px 0px 10px;">
                    <i class="bi-x-circle" title="Apagar notificação" @click="apagarNotificacao(notif)"></i>
                    <div style="text-align: right; white-space: nowrap; display: flex; align-items: flex-end;">
                      {{ timeSince(notif) }}
                    </div>
                  </div>
                </div>
                <hr style="border: 1px solid #ddd; margin: 3px 0" />
              </div>
              <div v-if="notifLoading" class="fonte-fraca notif-loading">Carregando...</div>
              <div v-else-if="!notifHasMore && notificacoes.length" class="fonte-fraca notif-loading">Fim das notificações</div>
            </div>
            <template v-if="notificacoes.length">
              <span class="chip fonte-fraca direita" style="margin-bottom: 5px; margin-top: auto"
                @click="apagarNotificacoesLidas">Limpar lidas</span>
              <span class="chip fonte-fraca direita bg-erro" style="margin-bottom: 5px; margin-top: auto; cursor: pointer"
                @click="apagarTodasNotificacoes">Apagar Todas</span>
            </template>
          </nav>
        </div>
        <div class="header-profile">
          <a href="#" class="avatar direita"
            onclick="document.getElementById('usuario').classList.toggle('none');this.classList.toggle('ativo');return false"
            :title="user?.nome">
            <img
              class="avatar-img"
              :class="{ 'avatar-img--placeholder': !pessoa.path_image }"
              :style="{ filter: theme == 'dark' && !pessoa.path_image ? 'invert(100%)' : null }"
              :src="baseUrl + pessoa.path_image || 'https://cdn-icons-png.flaticon.com/128/709/709722.png'" />
          </a>

          <nav class="jm jm-avatar none" id="usuario">
            <div class="separador margem alinha-centro negrito">
              {{ user.nome }}
              <div v-if="contaAtivaLabel" class="fonte-menor fonte-fraca" style="font-weight: normal; margin-top: 4px">
                {{ contaAtivaLabel }}
              </div>
            </div>
            <div class="separador" v-if="contasSalvas.length">
              <div class="fonte-menor fonte-fraca" style="padding: 6px 12px">Contas neste dispositivo</div>
              <a
                v-for="conta in contasSalvas"
                :key="conta.key"
                href="#"
                :class="{ ativo: conta.ativa }"
                @click.prevent="trocarConta(conta)"
                style="display: flex; justify-content: space-between; align-items: center; gap: 8px"
              >
                <span>
                  {{ conta.nome }}
                  <span v-if="conta.empresa_nome || conta.empresa_id" class="fonte-menor fonte-fraca">
                    — {{ conta.empresa_nome || ('Empresa ' + conta.empresa_id) }}
                  </span>
                  <span v-if="conta.ativa" class="fonte-menor"> (atual)</span>
                </span>
                <span
                  v-if="!conta.ativa"
                  class="fonte-menor"
                  title="Remover da lista"
                  @click.stop.prevent="removerConta(conta)"
                >✕</span>
              </a>
              <a href="#" @click.prevent="adicionarConta">Adicionar conta</a>
            </div>
            <div class="separador" v-else>
              <a href="#" @click.prevent="adicionarConta">Adicionar conta</a>
            </div>
            <div class="separador">
              <a :href="linkDadosCadastrais">Dados Cadastrais</a>

              <a href="#" :class="theme == 'dark' ? 'ativo' : ''"
                onclick="document.documentElement.classList.toggle('dark');this.classList.toggle('ativo');return false"
                @click="setTheme()"><span class="direita toggle"></span>Tema escuro</a>
              <a>
                <ResetPasswordTile />
              </a>
            </div>
            <div class="separador bg-cinza">
              <a href="#" @click.prevent="logout">Sair</a>
              <a href="#" @click.prevent="logoutTodas" v-if="contasSalvas.length > 1">Sair de todas</a>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { sso } from "roboflex-thalamus-sso-lib";
import {
  ensureActiveAccountInVault,
  enriquecerUsuarioComMe,
  getUsuarioContexto,
  listSavedAccounts,
  logoutActiveAccount,
  logoutAllAccounts,
  removeSavedAccount,
  switchAccount,
  urlAdicionarConta,
} from "roboflex-thalamus-request-handler";
import headerMenuService from "@/services/headerMenuService";
import { NotificationService } from "../services/notificationServices";
import ResetPasswordTile from "./ResetPasswordTile.vue";
import { storageBaseUrl } from "@/globals";
import pkg from "../../package.json";

export default {
  name: "HeaderComponent",
  components: {
    ResetPasswordTile,
  },
  data() {
    return {
      libVersion: pkg.version,
      user: null,
      pessoa: {},
      theme: null,
      notificacoes: [],
      baseUrl: storageBaseUrl(),
      notifService: new NotificationService(this.buildMode),
      contasSalvas: [],
      empresaNome: "",
      notifDropdownAberto: false,
      notifPage: 0,
      notifPerPage: 5,
      totalNotificacoes: 0,
      notifHasMore: true,
      notifLoading: false,
      linkPortal: "",
      menus: [],
      linkDadosCadastrais: "",
    };
  },

  mounted() {
    this.getPessoa();
    this.getNotificacoes({ reset: true });
    this.carregarContasSalvas();
    this.carregarEmpresaNome();
  },

  props: {
    moduleName: {
      type: String,
      default: "",
      required: true,
    },
    buildMode: {
      type: String,
      default: "",
      required: true,
    },
  },
  computed: {
    getModuleName() {
      return this.moduleName;
    },
    contaAtivaLabel() {
      const ativa = this.contasSalvas.find((c) => c.ativa);
      if (!ativa) return "";
      if (ativa.empresa_nome) return ativa.empresa_nome;
      if (ativa.empresa_id != null && ativa.empresa_id !== "") {
        return `Empresa ${ativa.empresa_id}`;
      }
      return ativa.is_root ? "Root" : "";
    },
    nomeEmpresaHeader() {
      if (this.empresaNome) return this.empresaNome;
      return this.contaAtivaLabel || "";
    },
    nomeUsuarioCurto() {
      const nome = String(this.user?.nome || "").trim();
      if (!nome) return "";
      const partes = nome.split(/\s+/).filter(Boolean);
      if (partes.length === 1) return partes[0];
      return `${partes[0]} ${partes[partes.length - 1]}`;
    },
    tituloIdentidadeHeader() {
      const partes = [];
      if (this.user?.nome) partes.push(String(this.user.nome).trim());
      if (this.nomeEmpresaHeader) partes.push(this.nomeEmpresaHeader);
      return partes.join(" — ");
    },
  },

  async created() {
    this.user = sso.getUsuarioLogado();
    this.theme = localStorage.getItem("tema");
    if (this.theme == null) {
      localStorage.setItem("tema", "light");
    } else {
      document.documentElement.classList.toggle(this.theme);
    }
    try {
      ensureActiveAccountInVault();
    } catch {
      // ignore
    }
    this.linkPortal = headerMenuService.linkPortal(this.buildMode);
    this.linkDadosCadastrais = headerMenuService.linkDadosCadastrais(this.buildMode);
    this.carregarModulos();
  },

  methods: {
    async carregarModulos() {
      try {
        this.menus = await headerMenuService.buscarModulos();
      } catch (e) {
        console.error(e);
        this.menus = [];
      }
    },
    carregarContasSalvas() {
      try {
        this.contasSalvas = listSavedAccounts();
      } catch {
        this.contasSalvas = [];
      }
    },
    async carregarEmpresaNome() {
      try {
        const contexto = getUsuarioContexto();
        if (contexto?.empresa_nome) {
          this.empresaNome = String(contexto.empresa_nome);
        }
        const me = await enriquecerUsuarioComMe();
        if (me?.empresa_nome) {
          this.empresaNome = String(me.empresa_nome);
          try {
            ensureActiveAccountInVault();
            this.carregarContasSalvas();
          } catch {
            // ignore
          }
        }
      } catch {
        // mantém fallback do cofre
      }
    },
    async getPessoa() {
      this.pessoa = await headerMenuService.getPessoa();
    },
    trocarConta(conta) {
      if (!conta || conta.ativa) return;
      try {
        switchAccount(conta.key);
      } catch (e) {
        console.error(e);
        alert(e?.message || "Não foi possível trocar de conta.");
      }
    },
    removerConta(conta) {
      if (!conta || conta.ativa) return;
      try {
        removeSavedAccount(conta.key, { reload: false });
        this.carregarContasSalvas();
      } catch (e) {
        console.error(e);
      }
    },
    adicionarConta() {
      const portal = this.linkPortal || "/";
      const returnUrl = typeof window !== "undefined" ? window.location.href : "";
      window.location.href = urlAdicionarConta(portal, returnUrl);
    },
    logout() {
      try {
        logoutActiveAccount();
      } catch {
        try {
          sso.logout();
        } catch {
          // segue
        }
        if (typeof document !== "undefined") {
          const past = "Thu, 01 Jan 1970 00:00:00 GMT";
          const base = `thalamusSession=; path=/; expires=${past}; max-age=0; SameSite=Lax`;
          document.cookie = base;
          document.cookie = `${base}; domain=thalamus.ind.br`;
        }
      }
      window.location.href = (this.linkPortal || "/") + "login";
    },
    logoutTodas() {
      try {
        logoutAllAccounts();
      } catch {
        this.logout();
        return;
      }
      window.location.href = (this.linkPortal || "/") + "login";
    },

    setTheme() {
      if (this.theme == "light") {
        localStorage.setItem("tema", "dark");
        this.theme = "dark";
      } else {
        localStorage.setItem("tema", "light");
        this.theme = "light";
      }
    },

    async apagarNotificacoesLidas() {
      var ids = this.notificacoes.filter(i => i.status == 1).map((item) => item.id);
      if (!ids.length) return;
      var response = await this.notifService.apagarNotificacoes(ids);
      if (response) {
        await this.getNotificacoes({ reset: true });
      }
    },

    async apagarTodasNotificacoes() {
      if (this.notificacoes.length === 0) return;
      var ids = this.notificacoes.map((item) => item.id);
      var response = await this.notifService.apagarNotificacoes(ids);
      if (response) {
        await this.getNotificacoes({ reset: true });
      }
    },

    async apagarNotificacao(notif) {
      var response = await this.notifService.apagarNotificacoes([notif.id]);
      if (response) {
        this.notificacoes = this.notificacoes.filter((n) => n.id !== notif.id);
        this.totalNotificacoes = Math.max(0, this.totalNotificacoes - 1);
        if (this.notificacoes.length < this.notifPerPage && this.notifHasMore) {
          await this.getNotificacoes({ reset: false });
        }
      }
    },

    async lerNotificacao(notif) {
      var url = this.buildMode == 'development' ? 'http://projetos-homologacao.thalamus.ind.br/#/' : 'https://projetos.thalamus.ind.br/#/'
      await this.notifService.lerNotificacao([notif.id]);
      if (notif.tipo == 'EntregasProjeto') {
        window.open(`${url}projeto/${notif.info.projeto_id}`, '_blank')
      }
      if (notif.tipo == 'SprintTarefa' && notif.info?.projeto_id) {
        const params = new URLSearchParams();
        if (notif.info.entrega_id) params.set('entrega_id', notif.info.entrega_id);
        if (notif.info.sprint_id) params.set('sprint_id', notif.info.sprint_id);
        if (notif.info.id) params.set('destaque_tarefa_id', notif.info.id);
        const query = params.toString();
        window.open(`${url}projeto/${notif.info.projeto_id}${query ? '?' + query : ''}`, '_blank')
      }
      if (notif.tipo == 'ProtocoloTarefa' && notif.info?.protocolo_id) {
        const tipoId = notif.info.protocolo_tipo_id;
        const protocoloId = notif.info.protocolo_id;
        const params = new URLSearchParams();
        if (notif.info.id) params.set('destaque_tarefa_id', notif.info.id);
        const query = params.toString();
        let path = tipoId == 6 ? `grupo/${protocoloId}` : tipoId == 7 ? `reuniao/${protocoloId}` : `protocolo/${protocoloId}`;
        window.open(`${url}${path}${query ? '?' + query : ''}`, '_blank')
      }
      if (notif.tipo === 'OrdemServico2' && notif.info?.id) {
        const path = notif.info.rota_demandas || `ordem-servico/${notif.info.id}/editar-assistencia`;
        window.open(`${window.location.origin}/#/${path}`, '_blank');
      }
      notif.status = 1;
    },

    toggleNotificacoes() {
      const abrindo = !this.notifDropdownAberto;
      this.notifDropdownAberto = abrindo;
      if (abrindo && this.notificacoes.length === 0 && this.notifHasMore && !this.notifLoading) {
        this.$nextTick(() => {
          this.getNotificacoes({ reset: true });
        });
      }
    },

    onNotifScroll(event) {
      const el = event?.target;
      if (!el || this.notifLoading || !this.notifHasMore) return;
      const distanciaFim = el.scrollHeight - el.scrollTop - el.clientHeight;
      if (distanciaFim <= 40) {
        this.getNotificacoes({ reset: false });
      }
    },

    async getNotificacoes({ reset = false } = {}) {
      if (this.notifLoading) return;
      if (!reset && !this.notifHasMore) return;

      const nextPage = reset ? 1 : this.notifPage + 1;
      this.notifLoading = true;
      try {
        const { data, meta } = await this.notifService.getNotificacoes({
          page: nextPage,
          perPage: this.notifPerPage,
        });

        const ordenadas = [...(data || [])].sort((a, b) => {
          const dateA = new Date(a.info?.created_at || "1970-01-01T00:00:00Z");
          const dateB = new Date(b.info?.created_at || "1970-01-01T00:00:00Z");
          return dateB - dateA;
        });

        if (reset) {
          this.notificacoes = ordenadas;
        } else {
          const ids = new Set(this.notificacoes.map((n) => n.id));
          this.notificacoes = [
            ...this.notificacoes,
            ...ordenadas.filter((n) => !ids.has(n.id)),
          ];
        }

        this.notifPage = meta.current_page;
        this.totalNotificacoes = meta.total;
        this.notifHasMore = meta.has_more;
      } catch (e) {
        console.error(e);
        if (reset) {
          this.notificacoes = [];
          this.totalNotificacoes = 0;
          this.notifHasMore = false;
        }
      } finally {
        this.notifLoading = false;
      }
    },

    timeSince(notif) {
      if (!notif || !notif.info || !notif.info.created_at) {
        return "Sem data";
      }
      const createdAt = notif.info.created_at;
      const diferença = new Date() - new Date(createdAt);
      const diferençaMinutos = Math.floor(diferença / (1000 * 60));
      const diferençaHoras = Math.floor(diferença / (1000 * 60 * 60));
      const diferençaDias = Math.floor(diferença / (1000 * 60 * 60 * 24));

      if (diferençaMinutos < 60) {
        return `${diferençaMinutos} min`;
      } else if (diferençaHoras < 24) {
        return `${diferençaHoras} h`;
      } else {
        return `${diferençaDias} ${diferençaDias > 1 ? "dias" : "dia"}`;
      }
    },
  },
};
</script>

<style>

.empresa-header {
  display: flex;
  flex-direction: column;
  max-width: 180px;
  font-size: 0.9rem;
  color: var(--cor-fonte);
  line-height: 1.2;
  text-align: center;
}

.empresa-header__nome,
.empresa-header__empresa {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empresa-header__empresa {
  font-weight: 600;
}

.header-profile {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.header-profile .jm-avatar {
  top: calc(100% + 8px);
  right: 0;
  left: auto;
  margin-top: 0 !important;
  max-height: min(70vh, calc(100vh - 72px));
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 20;
}

.header-notif {
  position: relative;
}

.header-notif .jm-notif {
  top: calc(100% + 8px);
  right: 0;
  left: auto;
  margin-top: 0 !important;
  margin-right: 0 !important;
  z-index: 20;
}

.jm-notif {
  max-width: 380px !important;
  width: 380px !important;
}

.notif-lista {
  max-height: 320px;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.notif-item .texto {
  margin: 0;
}

.notif-loading {
  padding: 8px 12px;
  text-align: center;
  font-size: 0.85rem;
}

.chip {
  cursor: pointer;
}

.texto {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  cursor: pointer;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.white-profile {
  filter: invert(100%) !important;
}

/* Avatar: círculo fixo + object-fit para não distorcer a foto */
.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-top: 3px !important;
  border: 1px solid var(--cor-primaria);
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 1.2px !important;
}

.avatar .avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.avatar .avatar-img--placeholder {
  object-fit: contain;
  padding: 8px;
}

a:not(.avatar) > img {
  height: 36px !important;
  width: 36px !important;
}

.bi-x-circle {
  cursor: pointer;
  color: var(--cor-erro);
  font-size: 16px;
}

.bi-x-circle:hover {
  transition: all 200ms ease-in;
  font-size: 18px;
}
</style>
